__turbopack_context__.v({
  "copyright": "MainFooter-module-scss-module__ieQtua__copyright",
  "footer": "MainFooter-module-scss-module__ieQtua__footer",
  "link": "MainFooter-module-scss-module__ieQtua__link",
  "list": "MainFooter-module-scss-module__ieQtua__list",
  "menu": "MainFooter-module-scss-module__ieQtua__menu",
  "nav": "MainFooter-module-scss-module__ieQtua__nav",
  "socialIcons": "MainFooter-module-scss-module__ieQtua__socialIcons",
});
